import { render, staticRenderFns } from "./SamplesThumbnailView.vue?vue&type=template&id=7f5ef70a&"
import script from "./SamplesThumbnailView.vue?vue&type=script&lang=js&"
export * from "./SamplesThumbnailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports